import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { useBnbSelector } from "../../../redux/store";
import type { ExtraType } from "../../../../../../common-deprecated/types/CommonTypes";
import { find } from "../../../../../../common-deprecated/utils";
import { addExtra, removeExtra, setExtraOption } from "../../../redux/actions/BasketActions";
import { trackCustomizeConfigItem } from "../../../utils/tracking";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

export type MostPopularExtrasType = {
    mostPopularExtras: { extra: ExtraType; checked: boolean }[];
    modelName: string;
    onAddExtra: (extra: ExtraType) => void;
    onRemoveExtra: (extra: ExtraType) => void;
    onSetExtraOption: (extra: ExtraType, extraOptionId: string) => void;
};

const useMostPopularExtras = (): MostPopularExtrasType => {
    const car = useBnbSelector((state) => state.car);
    const items = useBnbSelector((state) => state.items);
    const basket = useBnbSelector((state) => state.basket);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const mostPopular = items.extras
        .filter((extra) => extra.isMostPopular)
        .sort((a, b) => {
            return a.mostPopularIndex - b.mostPopularIndex;
        })
        .map((extra) => ({
            checked: !!find(extra.id, basket.extras),
            extra,
        }));

    return {
        mostPopularExtras: mostPopular,
        modelName: car.model.webtitleSectionName,
        onAddExtra: (extra) => {
            trackCustomizeConfigItem(NavStep.Customize, "add-extra-popular");
            dispatch(addExtra(extra, false, true));
        },
        onRemoveExtra: (extra) => {
            trackCustomizeConfigItem(NavStep.Customize, "remove-extra");
            dispatch(removeExtra(extra, false, true));
        },
        onSetExtraOption: (extra, option) => dispatch(setExtraOption(extra, option, true)),
    };
};

export default useMostPopularExtras;
